// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5":"d631df0c76c84455","19":"b1b87f88c07b5354","60":"2cdc12b5ceb1a82a","175":"300609ab8dc0634a","284":"b6e2c6f86b9dc713","565":"462f0fe6d642517a"}[chunkId] + ".js";
};